import { App } from '@/core/App.js'

const CHUNK_RECOVERY_KEY = 'performanse:chunk-recovery'
const CHUNK_ERROR_PATTERNS = [
  /Failed to fetch dynamically imported module/i,
  /Importing a module script failed/i,
  /Unable to preload CSS for/i,
  /Loading chunk [\w-]+ failed/i,
]

const toErrorMessage = (value) => {
  if (!value) return ''
  if (typeof value === 'string') return value
  if (value instanceof Error) return value.message || String(value)
  if (typeof value.reason === 'string') return value.reason
  if (value.reason instanceof Error) return value.reason.message || String(value.reason)
  if (typeof value.message === 'string') return value.message
  return String(value)
}

const isChunkLoadFailure = (value) => {
  const message = toErrorMessage(value)
  if (!message) return false

  // Guard CSS preload recovery to hashed local Vite assets only.
  if (/Unable to preload CSS for/i.test(message)) {
    const match = message.match(/(\/(?:dist\/)?assets\/[^'"\s]+\.css)/i)
    return Boolean(match && isViteHashedAsset(match[1]))
  }

  return CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(message))
}

const isViteHashedAsset = (source) => {
  if (!source) return false

  try {
    const url = new URL(source, window.location.href)
    if (url.origin !== window.location.origin) return false

    return /\/(?:dist\/)?assets\/.+-[a-zA-Z0-9]{8,}\.(js|css)$/.test(url.pathname)
  } catch (error) {
    return false
  }
}

const triggerChunkRecovery = () => {
  if (sessionStorage.getItem(CHUNK_RECOVERY_KEY) === '1') {
    return false
  }

  sessionStorage.setItem(CHUNK_RECOVERY_KEY, '1')
  const url = new URL(window.location.href)
  url.searchParams.set('_chunk_recover', Date.now().toString())
  window.location.replace(url.toString())
  return true
}

window.addEventListener('unhandledrejection', (event) => {
  if (isChunkLoadFailure(event)) {
    if (triggerChunkRecovery()) {
      event.preventDefault()
    }
  }
})

window.addEventListener(
  'error',
  (event) => {
    if (isChunkLoadFailure(event.error || event.message)) {
      triggerChunkRecovery()
      return
    }

    const target = event.target
    if (!target) return
    const isAssetTag = target.tagName === 'SCRIPT' || target.tagName === 'LINK'
    if (!isAssetTag) return

    const source = target.src || target.href || ''
    if (isViteHashedAsset(source)) {
      triggerChunkRecovery()
    }
  },
  true
)

App.init()

// Clean up _chunk_recover param from URL after successful load (cosmetic only)
// IMPORTANT: we only remove the URL param, never the sessionStorage guard key
window.addEventListener('load', () => {
  const url = new URL(window.location.href)
  if (url.searchParams.has('_chunk_recover')) {
    url.searchParams.delete('_chunk_recover')
    window.history.replaceState({}, '', url.toString())
  }
})
